// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"../../"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6bce4eec","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/page/user/mine/MineIndex.vue
// module id = 1348
// module chunks = 0